import PageNotFound from "@/views/system/PageNotFound.vue";
import redirectToLogin from "@/router/system/middleware/redirectToLogin";
import Login from "@/views/system/Login.vue";
import hideError from "@/router/system/middleware/hideError";
import closeModals from "@/router/system/middleware/closeModals";
import resetFooterCounter from "@/router/system/middleware/resetFooterCounter";
import checkToken from "@/router/system/middleware/checkToken";
import Account from "@/views/system/Account.vue";
import Changelog from "@/views/system/Changelog.vue";
import Error from "@/views/system/Error.vue";
import Logout from "@/views/system/Logout.vue";
import OAuthCallback from "@/views/system/oauth/OAuthCallback.vue";
import OAuthSilentCallback from "@/views/system/oauth/OAuthSilentCallback.vue";
import OAuthSsoCallback from "@/views/system/oauth/OAuthSsoCallback.vue";
import SamlCallback from "@/views/system/saml/SamlCallback.vue";

export default [
    {
        path: '/',
        name: 'Home',
        component: PageNotFound, // THIS IS ONLY A PLACEHOLDER
        meta: {
            middleware: [redirectToLogin],
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: '/account',
        name: 'Account',
        components: {
            default: Account,
            LeftSidebar: () => import('@/components/Sidebar.vue'),
        },
        meta: {
            middleware: [hideError, checkToken, closeModals, resetFooterCounter],
        }
    },
    {
        path: '/changelog',
        name: 'Changelog',
        components: {
            default: Changelog,
            LeftSidebar: () => import('@/components/Sidebar.vue'),
        },
        meta: {
            middleware: [hideError, checkToken, closeModals, resetFooterCounter],
        }
    },
    {
        path: '/error',
        name: 'Error',
        components: {
            default: Error,
            LeftSidebar: () => import('@/components/Sidebar.vue'),
        },
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: "/logout",
        name: 'Logout',
        component:  Logout,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: "/saml/SamlCallback",
        name: 'SamlCallback',
        component: SamlCallback,
    },
    {
        path: "/sso/oAuthCallback",
        name: 'OAuthCallback',
        component: OAuthCallback,
    },
    {
        path: "/sso/oAuthCallback/silent",
        name: 'OAuthSilentCallback',
        component: OAuthSilentCallback,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        component:  PageNotFound,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
]
